import {
  SET_PLACE_PICKER_POSITION,
  ACTIVATE_PLACE_PICKER,
  DEACTIVATE_PLACE_PICKER,
  SHOW_PLACE_PICKER,
  HIDE_PLACE_PICKER,
  SET_PLACE_ID,
  SET_PLACE_TITLE
} from '@/store/mutation-types'
import { MAP_CENTER } from '@/assets/js/map'
import isInWarsaw from '@/assets/js/map/isInWarsaw'

const state = {
  position: MAP_CENTER,
  placeId: 0,
  isActive: false,
  isValid: false,
  isVisible: false,
  wasChanged: false,
  title: ''
}

const getters = {
  placeTitle (state) {
    return state.isValid ? state.title : ''
  }
}

const mutations = {
  [SET_PLACE_PICKER_POSITION] (state, coords) {
    state.position = coords
    state.wasChanged = true
    state.isValid = isInWarsaw(coords)
  },
  [ACTIVATE_PLACE_PICKER] (state) {
    state.isActive = true
  },
  [DEACTIVATE_PLACE_PICKER] (state) {
    // Reset state
    state.title = ''
    state.wasChanged = false
    state.isActive = false
  },
  [SHOW_PLACE_PICKER] (state) {
    state.isVisible = true
  },
  [HIDE_PLACE_PICKER] (state) {
    state.isVisible = false
  },
  [SET_PLACE_ID] (state, id) {
    state.placeId = id
  },
  [SET_PLACE_TITLE] (state, title) {
    state.title = title
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/picker.js